// Keep in sync with migrations/1787095681-add-site-navigation-to-template.js.
export const SITE_NAVIGATION_OPTIONS = [
  'Visible',
  'Minimal',
  'Hidden',
] as const;

export type SiteNavigationOption = (typeof SITE_NAVIGATION_OPTIONS)[number];

export type NavigationVariant = 'default' | 'minimal';

type TemplateNavigationFields = {
  siteNavigation?: unknown;
  hideSiteNav?: unknown;
};

/**
 * The legacy `hideSiteNav` fallback covers entries the data migration hasn't
 * reached, so code and migration can deploy in any order.
 */
export const resolveSiteNavigation = (
  fields?: TemplateNavigationFields | null,
): SiteNavigationOption => {
  const value = fields?.siteNavigation;

  if ((SITE_NAVIGATION_OPTIONS as readonly unknown[]).includes(value)) {
    return value as SiteNavigationOption;
  }

  return fields?.hideSiteNav ? 'Hidden' : 'Visible';
};
